import React from "react";
// instancia axios del API (agrega el Bearer en cada peticion)
import http from "../../http";

// @material-ui/core components
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";

import BrokenImageIcon from "@material-ui/icons/BrokenImage";

// Imagen protegida por JWT: el API la sirve solo con Authorization, por lo que
// no se puede usar <img src> directo contra el endpoint. Se baja como blob con
// la instancia http, se crea un objectURL (revocado en el cleanup del efecto),
// se muestra un thumbnail clickeable y al hacer click se abre un Dialog con la
// imagen completa. Carga: CircularProgress; error: icono roto + texto generico
// (no se parsea el blob de error — suficiente).
function ImagenAuth(props) {
  const { src, alt, altura } = props;

  const [objectUrl, setObjectUrl] = React.useState(null);
  const [error, setError] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    let vigente = true;
    let url = null;
    setObjectUrl(null);
    setError(false);
    http
      .get(src, { responseType: "blob" })
      .then(function(response) {
        url = window.URL.createObjectURL(response.data);
        if (vigente) {
          setObjectUrl(url);
        } else {
          // el componente ya se desmonto (o cambio src) antes de que llegara
          window.URL.revokeObjectURL(url);
          url = null;
        }
      })
      .catch(function() {
        if (vigente) {
          setError(true);
        }
      });
    return function cleanup() {
      vigente = false;
      if (url) {
        window.URL.revokeObjectURL(url);
      }
    };
  }, [src]);

  const alturaThumbnail = altura || 90;

  if (error) {
    return (
      <div
        style={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: alturaThumbnail,
          height: alturaThumbnail,
          margin: 4,
          border: "1px dashed #bdbdbd",
          borderRadius: 6,
          color: "#9e9e9e",
          verticalAlign: "middle"
        }}
      >
        <BrokenImageIcon />
        <span style={{ fontSize: 10, textAlign: "center" }}>No disponible</span>
      </div>
    );
  }

  if (!objectUrl) {
    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: alturaThumbnail,
          height: alturaThumbnail,
          margin: 4,
          verticalAlign: "middle"
        }}
      >
        <CircularProgress size={24} />
      </div>
    );
  }

  return (
    <React.Fragment>
      <img
        src={objectUrl}
        alt={alt || "Evidencia"}
        style={{
          height: alturaThumbnail,
          width: "auto",
          maxWidth: 160,
          margin: 4,
          borderRadius: 6,
          border: "1px solid #e0e0e0",
          cursor: "pointer",
          objectFit: "cover",
          verticalAlign: "middle"
        }}
        onClick={() => setOpen(true)}
      />
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <DialogContent style={{ padding: 8, textAlign: "center" }}>
          <img
            src={objectUrl}
            alt={alt || "Evidencia"}
            style={{ maxWidth: "100%", maxHeight: "80vh", cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

export default ImagenAuth;
